module.exports = __webpack_public_path__ + "static/media/user.86c2a58a.png";